import { useState } from "react";
import { FileDown, Loader2, Printer } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { api, errorMessage } from "../../lib/api";
import { useLang } from "../../context/LanguageContext";

/** Opnar ein PDF frå eit innlogga endepunkt i ny fane (blob-URL, same mønster som utleveringslista). */
export async function openProtectedPdf(path, params = {}) {
  const res = await api.get(path, { responseType: "blob", params });
  const url = URL.createObjectURL(res.data);
  const win = window.open(url, "_blank", "noopener");
  if (!win) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

/**
 * Plakat-knappar (A4/A3) + valfri gåveregister-knapp for ein basar. Plakaten viser basarnamn, trekningstidspunkt/stad (stad skjult ved
 * elektronisk trekning), dei største premiane med bilete, resten som liste, merknad (om fylt ut) og QR til basarsida – aldri givarar.
 */
export const PosterButtons = ({ basarId, size = "sm", variant = "secondary", withRegister = false, className = "" }) => {
  const { t } = useLang();
  const [busy, setBusy] = useState("");
  const open = async (key, path, params) => {
    setBusy(key);
    try {
      await openProtectedPdf(path, params);
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setBusy("");
    }
  };
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="basar-poster-buttons">
      <Button variant={variant} size={size} onClick={() => open("A4", `/my/basar/${basarId}/poster.pdf`, { size: "A4" })} disabled={busy !== ""} data-testid="basar-poster-a4-button">
        {busy === "A4" ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Printer className="w-4 h-4 mr-1.5" />} {t("Plakat A4")}
      </Button>
      <Button variant={variant} size={size} onClick={() => open("A3", `/my/basar/${basarId}/poster.pdf`, { size: "A3" })} disabled={busy !== ""} data-testid="basar-poster-a3-button">
        {busy === "A3" ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Printer className="w-4 h-4 mr-1.5" />} {t("Plakat A3")}
      </Button>
      {withRegister && (
        <Button variant={variant} size={size} onClick={() => open("reg", `/my/basar/${basarId}/gifts.pdf`)} disabled={busy !== ""} data-testid="basar-gift-register-pdf-button">
          {busy === "reg" ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <FileDown className="w-4 h-4 mr-1.5" />} {t("Gaveregister (PDF)")}
        </Button>
      )}
    </div>
  );
};
